export default __webpack_public_path__ + "static/media/contact_success_image.9bb686d5.png";